import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';
import ReactGA from 'react-ga';

import './signUp.scss';
import FormTitleComponent from '../../../components/core/FormTitleComponent/FormTitleComponent';
import SignUpFormFieldsLayout from '../../../layouts/SignUp/SignUpFormFieldsLayout';
import { SIGN_UP_PATH, SIGN_IN_PATH } from '../../../constants/routes';

class SignUpPersonalComponent extends React.Component {
    render() {
        const { history, handleSubmit, invalid } = this.props;
        const goToSignInPage = () => {
            ReactGA.event({
                category: 'Sign In Component',
                action: 'Clicked Login',
                label: 'Button',
            });
            history.push(SIGN_IN_PATH, { prevPath: SIGN_UP_PATH });
        }

        return <Form onSubmit={handleSubmit}>
            <FormTitleComponent title="Personal Information" />
            <SignUpFormFieldsLayout />
            <Button disabled={invalid} type="submit" className="next">Next</Button>
            <div className="divider">
                <hr className="left" />
                <span>Or</span>
                <hr className="right" />
            </div>
            <Button onClick={goToSignInPage} className="tertiary">Log In</Button>
        </Form>
    }
}

SignUpPersonalComponent.propTypes = {
    history: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
};

export default SignUpPersonalComponent;



// WEBPACK FOOTER //
// ./src/components/login/SignUp/SignUpPersonalComponent.js